export default "__VITE_ASSET__mPJwh0WA__"